define([
    'text!cooperate/component/item-grocery.html',
    'cooperate/mixin/form'
], function(
    tpl,
    FormMixin
){
    return {
        template: tpl,
        mixins: [FormMixin],
        methods: {
            resetForm: function(){
                this.form = {
                    type: 3,
                    companyName: '',
                    contact: '',
                    tel: '',
                    companyInfo: '',
                    attch: '',
                    remark: ''
                };
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./cooperate/component/item-grocery.js
// module id = 215
// module chunks = 0